/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const AgentExportType = core.serialization.enum_(["AUTOBUILD_INLINED", "SYSTEM_COMBINED", "SOURCE"]);
